//@flow
import React, { Component, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ListMobileCarousel } from 'components/molecules/listMobileCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import { RouteNames } from 'router';
import { ProjectSelector } from 'modules/project/selector';
import { ProjectActions } from 'modules/project/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { FilterButton } from 'components/atoms/filtersButton';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  recommendedList: Array,
  fetchTitle: Component,
  isDisplayLocationIcon: boolean,
  displayDistance?: boolean,
  innerHeight?: string,
  displayLocationBox?: boolean,
  onClick: () => void,
  toggleTag?: boolean,
};

const RecommendedMobileCarousel = (props: Props) => {
  const {
    recommendedList,
    fetchTitle,
    isDisplayLocationIcon,
    displayLocationBox,
    displayDistance,
    displayFullArea,
    onClick,
    toggleTag,
    type,
    filteredProjects,
    activeFilters,
    isFiltered,
    showFilter = false,
    breadcrumbList,
  } = props;
  const { height, isMobile } = useViewport();
  const [showProjects, setShowProjects] = useState(false);
  if (!recommendedList) {
    return null;
  }

  const showOverlay = showProjects ? (
    <OverlayPortal>
      <OverlayModal
        data={isFiltered ? filteredProjects : recommendedList}
        theme={isMobile ? 'light-theme' : 'dark-theme'}
        type={'projects'}
        onClosePress={() => setShowProjects(false)}
        activeFilters={activeFilters}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
          {
            breadcrumbName: breadcrumbList[2].breadcrumbName,
            breadcrumbLink: breadcrumbList[2].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  const projectList = isFiltered ? filteredProjects.list : recommendedList;
  return (
    <div className={'recommended-screen'} style={{ height }}>
      {showFilter && (
        <FilterButton
          className={`project-filter-mobile ${
            activeFilters.length > 0 ? 'highlight' : ''
          }`}
          isMobile={isMobile}
          theme={'light-theme'}
          activeFilters={activeFilters}
          filterType={'projects'}
        />
      )}
      <ListMobileCarousel
        data={projectList}
        fetchTitle={fetchTitle}
        onClick={onClick}
        type={type}
        isDisplayLocationIcon={isDisplayLocationIcon}
        displayDistance={displayDistance}
        displayFullArea={displayFullArea}
        displayLocationBox={displayLocationBox}
        toggleTag={toggleTag}
      />
      {showOverlay}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    filteredProjects: ProjectSelector.getFilteredProjects(state),
    activeFilters: ProjectSelector.getActiveProjectFilterNames(state),
    isFiltered: ProjectSelector.isProjectsFiltered(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleProjectFilter, clearProjectFilters } = ProjectActions;
  return bindActionCreators(
    {
      toggleProjectFilter,
      clearProjectFilters,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecommendedMobileCarousel);

export default withRouter(connectedComponent);
